import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as snakeToCamel } from './utils2.js';
import { T as radioListItem } from './parts.js';
import { d as defineCustomElement$2 } from './form-control-help-text2.js';
import { d as defineCustomElement$1 } from './form-control-radio2.js';

class PaymentMethodOption {
    constructor(paymentMethod) {
        this.id = paymentMethod.id;
        this.brand = paymentMethod.brand;
        this.acct_last_four = paymentMethod.acct_last_four;
        this.type = snakeToCamel(paymentMethod.type);
    }
}
var CardBrandLabels;
(function (CardBrandLabels) {
    CardBrandLabels["american_express"] = "American Express";
    CardBrandLabels["diners_club"] = "Diners Club";
    CardBrandLabels["discover"] = "Discover";
    CardBrandLabels["jcb"] = "JCB";
    CardBrandLabels["mastercard"] = "Mastercard";
    CardBrandLabels["china_unionpay"] = "UnionPay";
    CardBrandLabels["visa"] = "Visa";
    CardBrandLabels["unknown"] = "Unknown";
})(CardBrandLabels || (CardBrandLabels = {}));

const SavedPaymentMethod = /*@__PURE__*/ proxyCustomElement(class SavedPaymentMethod extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.paymentMethodOptionSelected = createEvent(this, "paymentMethodOptionSelected", 7);
        this.onPaymentMethodOptionClick = (e) => {
            e.preventDefault();
            this.paymentMethodOptionSelected.emit(this.paymentMethodOption);
        };
    }
    async resolvePaymentMethod(insuranceValidation) {
        var _a;
        if (!insuranceValidation.isValid) {
            return { validationError: true };
        }
        return { token: (_a = this.paymentMethodOption) === null || _a === void 0 ? void 0 : _a.id };
    }
    ;
    render() {
        var _a, _b, _c;
        return (h(Host, { key: '78487e52f549547f4c89f48a238a8916d77d4f1c', class: "payment-method" }, h("div", { key: 'd437a5f9e79356b1177703da2b5d7f4ca98072ce', class: "radio-list-item p-3", part: radioListItem, onClick: this.onPaymentMethodOptionClick }, h("form-control-radio", { key: '0dd03b9ebae98c441c63717aba310d77e587b1c8', name: "paymentMethodType", value: (_a = this.paymentMethodOption) === null || _a === void 0 ? void 0 : _a.id, checked: this.isSelected, label: `${CardBrandLabels[(_b = this.paymentMethodOption) === null || _b === void 0 ? void 0 : _b.brand] || ''} *${(_c = this.paymentMethodOption) === null || _c === void 0 ? void 0 : _c.acct_last_four}` }))));
    }
}, [0, "justifi-saved-payment-method", {
        "paymentMethodOption": [16, "payment-method-option"],
        "isSelected": [4, "is-selected"],
        "resolvePaymentMethod": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-saved-payment-method", "form-control-help-text", "form-control-radio"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-saved-payment-method":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SavedPaymentMethod);
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-radio":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { PaymentMethodOption as P, SavedPaymentMethod as S, defineCustomElement as d };
